/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (!getCookie(this.cookie) && (this.dataset.showOnMobile === 'true'
          || theme.mediaMatches.md)) {
          if (this.querySelector('.alert')) {
            this.open();
          } else if (this.dataset.trigger === 'delay') {
            const openAfterDelay = () => {
              const configuredDelay = Number(this.dataset.delay) * 1000;
              setTimeout(() => this.open(), Math.max(configuredDelay, 12000));
            };

            if (document.readyState === 'complete') {
              openAfterDelay();
            } else {
              window.addEventListener('load', openAfterDelay, { once: true });
            }
          } else if (this.dataset.trigger === 'exit' && theme.mediaMatches.md) {
            this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
            document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
          }
        }
      }

      /**
       * Opens the popup without changing the entire document to position: fixed.
       * Keeping the page in normal flow avoids repainting the product hero when
       * the delayed popup appears. Pointer scrolling outside the modal window is
       * prevented without changing document layout.
       *
       * @param {Element} opener - Popup opener element.
       */
      open(opener) {
        this.querySelectorAll('img[data-manual-src]').forEach((image) => {
          if (image.dataset.manualSrcset) image.srcset = image.dataset.manualSrcset;
          image.src = image.dataset.manualSrc;
          image.removeAttribute('data-manual-srcset');
          image.removeAttribute('data-manual-src');
        });

        this.scrollY = window.scrollY;
        this.setAttribute('open', '');
        this.openedBy = opener;

        trapFocus(this);
        window.pauseAllMedia();

        this.keyupHandler = (evt) => evt.key === 'Escape' && this.close();
        this.addEventListener('keyup', this.keyupHandler);

        this.querySelectorAll('table').forEach((table) => {
          if (table.parentElement.classList.contains('scrollable-table')) return;
          const wrapper = document.createElement('div');
          wrapper.className = 'scrollable-table';
          table.parentNode.insertBefore(wrapper, table);
          wrapper.appendChild(table);
        });

        this.preventBackgroundScroll = this.preventBackgroundScroll || ((evt) => {
          if (!evt.target.closest('.modal__window')) evt.preventDefault();
        });
        this.addEventListener('wheel', this.preventBackgroundScroll, { passive: false });
        this.addEventListener('touchmove', this.preventBackgroundScroll, { passive: false });
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }
      }

      /**
       * Handles 'mouseleave' events on the body.
       * @param {object} evt - Event object.
       */
      handleMouseLeave(evt) {
        if (evt.clientY < 0 && !getCookie(this.cookie)) this.open();
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        this.removeEventListener('wheel', this.preventBackgroundScroll);
        this.removeEventListener('touchmove', this.preventBackgroundScroll);
        super.close();
        setCookie(this.cookie, true, this.dataset.dismissDays);
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
